import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sort',
})
export class SortPipe implements PipeTransform {

    constructor() { }

    transform(obj: Object): Array<string> {
        let translatedValues: Array<string> = Object.keys(obj).map((key: string) => obj[key]);
        translatedValues.sort((str1: string, str2: string) => {
            return str1.toLocaleLowerCase().localeCompare(str2.toLocaleLowerCase());
        });
        return translatedValues;
    }

}
